import { SDT, SelectionApi, SelectionMode, SelectionState } from "./types"

export const initApi = (state_: SelectionState, setState_: SDT, muiGridApiRef: any): SelectionApi => {

  const setState = setState_

  const get = () => {
    const selection = muiGridApiRef.current?.getSelectedRows()
    return Array.from(selection.keys() as string[])
  }

  const set = (ids: string[]) => {
    setState((prev) => ({
      ...prev,
    }))
  }

  const setMode = (mode: SelectionMode) => {
    setState((prev) => ({
      ...prev,
      mode,
    }))
  }

  const toggleMode = () => {
    setState((prev) => ({
      ...prev,
      mode: prev.mode === SelectionMode.Page ? SelectionMode.All : SelectionMode.Page,
    }))
  }

  const reset = () => {
    muiGridApiRef.current.setSelectionModel([])

    setState((prev) => ({
      ...prev,
      mode: SelectionMode.Nothing,
    }))
  }

  return {
    setState,
    get,
    set,
    setMode,
    toggleMode,
    reset,
  }
}
